import { Controller } from "@hotwired/stimulus"
import toast from "../javascript/toast.js"

export default class extends Controller {
  connect() {
    const notice = this.element.dataset.notice
    const alert = this.element.dataset.alert

    if (notice) {
      toast.success(notice)
    }

    if (alert) {
      toast.error(alert)
    }
  }
}
